<template>
  <div id="crud-list-2-0" :class="[tableWrapperDynamicClassname]">
    <v-data-table class="hide-footer-select"
      v-model="selectedTasks"
      :item-key="itemKey"
      :headers="headers"
      :items="itemsGetter"
      :items-per-page.sync="paginationGetter.itemsperpage"
      :server-items-length="paginationGetter.serverItemsLength"
      :footer-props="paginationGetter.footerProps"
      @update:options="handleOptions"
      :fixed-header="enableFixedHeaders"
      :options="headersWithColsSpan"
      dense
      :show-select="showSelect"
      :loading="loadingData"
      :loading-text="loadingText"
      :hide-default-footer="hideDefaultFooter"
      :disable-pagination="disablePagination"
      :class="['elevation-1' , tableDynamicClassname]"
      :height="tableDynamicHeight"
    >
    <template v-slot:header="{ props }">
      <thead class="v-data-table-header" >
              <tr>
                <th v-for="data in props.options.MainHeadersNames"
                :key="data.id" :colspan="data.cols"
                :class="['text-center parent-header', data.cellClass]">
                  {{ data.text }}
                </th>
              </tr>
            </thead>
    </template>
    <template v-slot:top="{ pagination, options, updateOptions }">
      <v-toolbar
        v-if="displayTopPagination"
        flat
        class="mr-0 pr-0"
      >
        <v-spacer />
        <div>
          <v-data-footer
            :pagination="pagination"
            :options="options"
            @update:options="updateOptions"
            v-bind="paginationGetter.footerProps"
            items-per-page-text="$vuetify.dataTable.itemsPerPageText"
            :items-per-page.sync="paginationGetter.itemsperpage"
            :server-items-length="paginationGetter.serverItemsLength"
          />
        </div>
      </v-toolbar>
      <template v-if="showDialog">
        <slot name="additionalActionsTopAboveRow"/>
        <v-row>
        <v-col cols="2">
          <p class="font-weight-medium mb-0 text-field pt-2 pl-2"
          v-if="tableTitle">{{ tableTitle }}</p>
        </v-col>
        <v-col cols="8">
          <slot name="additionalActionsTop"/>
        </v-col>
      <v-col cols="1"
        class="d-flex justify-end">
        <v-btn
            id="add-new-base-item"
            v-if="canMultipleDelete"
            color="primary"
            fab icon small
            @click="handleMultipleDelete()"
            :disabled="isVisibleProp"
          >
            <v-icon small>
              {{icons.mdiDelete}}
            </v-icon>
          </v-btn>
        </v-col>
        <v-col cols="1"
        class="d-flex justify-end">
        <v-btn
            id="add-new-base-item"
            v-if="canAdd"
            color="primary"
            fab icon small
            @click="handleNewItem()"
            :disabled="isVisibleProp"
          >
            <v-icon small>
              {{icons.mdiPlus}}
            </v-icon>
          </v-btn>
          <v-tooltip bottom v-else-if="addDisabledTooltip">
            <template v-slot:activator="{ on, attrs }">
              <span v-bind="attrs" v-on="on">
                <v-btn
                  id="add-new-base-item"
                  color="primary"
                  fab icon small
                  disabled
                >
                  <v-icon small>
                    {{icons.mdiPlus}}
                  </v-icon>
                </v-btn>
              </span>
            </template>
            <span>{{ addDisabledTooltip }}</span>
          </v-tooltip>
        </v-col>
        </v-row>
       <CRUDDialog
            ref="crudDialog"
            :baseCrudKey="baseCrudKey"
            :canSave="canSave"
            :canSaveCustomLabel="canSaveCustomLabel"
            :canDeleteInDialog="canDeleteInDialogState"
            :dialogDynamicWidth="dialogDynamicWidth"
            :dialogDynamicHeight="dialogDynamicHeight"
            :canApply="canApply"
            :canCancel="canCancel"
            :closeOnEnter="closeOnEnter"
            :tabsList="tabsList"
            :dialogHeaderName="dialogHeaderName"
            :onlyDialogHeaderName="onlyDialogHeaderName"
            :overrideValidation="overrideValidation"
            @upsertItem="emitUpsertItem"
            @deleteItem="emitDeleteItem"
            @invalidItem="emitInvalidItem"
            @crudDialogClose="crudDialogClose"
            @crudDialogEnter="crudDialogEnter"
          >
            <template v-slot:[`editedItem`]="{}">
              <slot name="editedItem">
                <v-container>
                  <span>(this is the default template)</span>
                </v-container>
              </slot>
            </template>
            <template v-slot:[`additionalActions`]="{}">
              <slot name="additionalActions"/>
            </template>

              <template v-slot:[`additionalActionsAfterDelete`]="{}">
                <slot name="additionalActionsAfterDelete"/>
            </template>
            <template v-slot:[`additionalActionsAfterSave`]="{}">
                <slot name="additionalActionsAfterSave"/>
            </template>
          </CRUDDialog>
        </template>
    </template>
    <template v-slot:[`item`]="{ item, headers }">
      <Row
        :showSelect="showSelect"
        :selectedItems="selectedTasks"
        :canEdit="canEdit"
        :canDelete="canDelete"
        :canDownload="canDownload"
        :item="item"
        :items="itemsGetter"
        :canMove="canMove"
        :headers="headers"
        :uploadFileParams="uploadFileParams"
        :disableKeyboardFunc="disableKeyboardFunc"
        :formatPidPositions="formatPidPositions"
        :variableToChangeRowBgColor="variableToChangeRowBgColor"
        :hideCheckbox="hideCheckbox"
        :baseCrudKey="baseCrudKey"
        @editItem="handleEditItem"
        @emitRowButtonClick="handleRowButtonClick"
        @emitInlineSelectChange="handleInlineSelectChange"
        @emitRowIconClick="handleRowIconClick"
        @emitSelectedItem="handleSelectedTasks"
        @emitClickedItem="handleClickedTasks"
        @emitDeleteRowItem="deleteRowItem"
        @emitDownloadRowItem="downloadRowItem"
      />
    </template>
    <template v-slot:no-data>
      <span>{{ noResultOverride }}</span>
    </template>
   <template slot="body.append">
    <tr class="sticky-table-footer" v-if="footerTotalData.length">
      <td v-for="(data,index) in this.footerTotalData" :key="index">
        {{ data }}
      </td>
    </tr>
    <tr class="sticky-table-footer " v-if="footerTotalDisplayColumnWise.length">
      <td v-if="showSelect"></td>
          <td  v-for="(header, index) in headers" :key="index"
          :class="getAlignment(header.value)"
          :style="{
    color:
    header.value === 'feesAndPen'
        ? 'red'
        : 'black'
  }">
            <strong>
              {{
              footerTotalDisplayColumnWise[index]===''?calculateTotal(header.value):
              footerTotalDisplayColumnWise[index] }}
            </strong>
          </td>
        </tr>
    </template>
      <!-- The slot renders above the table's own pager. The 10/12 + 2/12 split is kept as
           percentages so the consumers that lay their footer out in columns to line up under
           the table above them - paymentTransactionList's and the credit-card TransactionList's
           totals rows - land where they did before.
           The `margin-bottom: -40px` that used to sit on the 10/12 column is gone: it pulled the
           pager up by 40px, so the page number and the back / next arrows printed straight
           through whatever the slot rendered (the large payment grid's Mtg Code / Running Total
           row is where that showed). Nothing compensated for it; the two simply overlapped. -->
      <template slot="footer">
        <div class="d-flex align-center crud-footer-bar" style="margin-top: -3px;">
          <div class="crud-footer-slot">
            <slot name="addidtionalCrudFooter"/>
          </div>
          <div class="crud-footer-spacer"></div>
        </div>
      </template>
      <!-- <template slot="footer" v-if="footerText">
        <p class="text-left" style="margin-bottom: -26px; color: #1976d2;
        padding-left: 10px;">{{ footerText }}</p>
      </template> -->
    </v-data-table>
  </div>
</template>

<script>
import {
  mdiPlus,
  mdiDelete,
} from '@mdi/js';
import {
  mapGetters,
  mapMutations,
} from 'vuex';
import { amountFormat, amountToNumber, isInsert } from '../../../../util/shared/vue-global';
import CRUDDialog from './CRUDDialog.vue';
import Row from './CRUDRow.vue';
import { getWorkstationNumber } from '../../../../util/workstation-util';
import '../../../../assets/style.css';

export default {
  name: 'CRUDList',
  components: {
    CRUDDialog,
    Row,
  },
  props: {
    itemKey: {
      type: String,
      default: '_id',
    },
    baseCrudKey: {
      type: String,
      default: 'default',
    },
    // the calling component has to tell us how to make a new item
    createNewItem: {
      type: Function,
      default: () => ({}),
    },
    headers: {
      type: Array,
      default: () => ([]),
    },
    headersWithColsSpan: {
      type: Object,
      default: () => ({}),
    },
    tabsList: {
      type: Array,
      default: () => ([]),
    },
    dataMapper: {
      type: Function,
      default: (itemData) => itemData,
    },
    defaultSortBy: {
      type: Array,
      default: () => undefined,
    },
    canAdd: {
      type: Boolean,
      default: false,
    },
    // When canAdd is false and this is set, the Add button stays visible but disabled, with this
    // text as its tooltip, instead of disappearing outright - so a user missing a role sees why
    // rather than wondering whether the feature exists at all.
    addDisabledTooltip: {
      type: String,
      default: '',
    },
    canEdit: {
      type: Boolean,
      default: false,
    },
    canMove: {
      type: Boolean,
      default: false,
    },
    canDelete: {
      type: Boolean,
      default: false,
    },
    canDeleteInDialog: {
      type: Boolean,
      default: false,
    },
    canSave: {
      type: Boolean,
      default: true,
    },
    canSaveCustomLabel: {
      type: String,
      default: 'Save',
    },
    dialogDynamicWidth: {
      type: String,
      default: '70vw',
    },
    // see CRUDDialog - empty means the dialog stays content-height, as every existing
    // caller expects; '90vh' is the tallest value Vuetify will honour.
    dialogDynamicHeight: {
      type: String,
      default: '',
    },
    canApply: {
      type: Boolean,
      default: false,
    },
    canCancel: {
      type: Boolean,
      default: true,
    },
    // see CRUDDialog - pass false when this list saves the record itself (canSave=false
    // plus a Save button in an additionalActions slot) so Enter reaches @crudDialogEnter
    // instead of closing the dialog and discarding the edits.
    closeOnEnter: {
      type: Boolean,
      default: true,
    },
    // if you don't want previous criteria pass false
    mergeCriteria: {
      type: Boolean,
      default: true,
    },
    uploadFileParams: {
      type: Object,
      default: () => ({}),
    },
    showSelect: {
      type: Boolean,
      default: false,
    },
    selectedItems: {
      type: Array,
      default: () => ([]),
    },
    footerTotalData: {
      type: Array,
      default: () => ([]),
    },
    footerTotalDisplayColumnWise: {
      type: Array,
      default: () => ([]),
    },
    dialogHeaderName: {
      type: String,
      default: '',
    },
    onlyDialogHeaderName: {
      type: String,
      default: '',
    },
    tableTitle: {
      type: String,
      default: '',
    },
    loadingData: {
      type: Boolean,
      default: false,
    },
    loadingText: {
      type: String,
      default: '',
    },
    displayTopPagination: {
      type: Boolean,
      default: true,
    },
    disablePagination: {
      type: Boolean,
      default: false,
    },
    hideDefaultFooter: {
      type: Boolean,
      default: false,
    },
    disableKeyboardFunc: {
      type: Boolean,
      default: true,
    },
    enableFixedHeaders: {
      type: Boolean,
      default: false,
    },
    showDialog: {
      type: Boolean,
      default: true,
    },
    tableWrapperDynamicClassname: {
      type: String,
      default: 'elevation-3 ma-3 pa-3',
    },
    tableDynamicClassname: {
      type: String,
      default: '',
    },
    tableDynamicHeight: {
      type: String,
      default: '400',
    },
    totals: {
      type: Boolean,
      default: false,
    },
    onSingleClickOpenDialog: {
      type: Boolean,
      default: false,
    },
    formatPidPositions: {
      type: String,
      default: '',
    },
    overrideValidation: {
      type: Boolean,
      default: false,
    },
    variableToChangeRowBgColor: {
      type: Array,
      default: () => ([]),
    },
    noResultOverride: {
      type: String,
      default: 'No data available',
    },
    hideCheckbox: {
      type: String,
      default: '',
    },
    removeHighlightOnDoubleClick: {
      type: Boolean,
      default: true,
    },
    useSelectedItemsStore: { // Selections will persist when navigating between pages
      type: Boolean,
      default: false,
    },
    canDownload: {
      type: Boolean,
      default: false,
    },
    canMultipleDelete: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    icons: {
      mdiPlus,
      mdiDelete,
    },
    canDeleteInDialogState: false,
  }),
  computed: {
    ...mapGetters('user', [
      'getSettings',
    ]),
    ...mapGetters('base/crud', [
      'items',
      'skipLimitPage',
      'isVisible',
      'paginationItems',
      'highlightedId',
      'selectedItemsOfAllPages',
    ]),
    selectedTasks: {
      get() {
        // If useSelectedItemsStore is true, use the store as source of truth
        // Otherwise, use the selectedItems prop (backward compatibility)
        if (this.useSelectedItemsStore) {
          return this.selectedItemsOfAllPages(this.baseCrudKey) || [];
        }
        return this.selectedItems || [];
      },
      set(value) {
        if (this.useSelectedItemsStore) {
          // When using store as source of truth, only update the store
          this.setSelectedItemsOfAllPages([this.baseCrudKey, value]);
        } else {
          // When using prop as source of truth, emit the event for backward compatibility
          this.$emit('emitSelectedItem', value);
        }
      },
    },
    itemsGetter() {
      const itemData = this.items(this.baseCrudKey);
      return this.dataMapper(itemData);
    },
    paginationGetter() {
      const paginationData = this.paginationItems(this.baseCrudKey);
      return paginationData;
    },
    getHighlightedId: {
      get() {
        return this.highlightedId(this.baseCrudKey) || '';
      },
      set(value) {
        this.setHighlightedId([this.baseCrudKey, value]);
      },
    },
    isVisibleProp() {
      const visibleFlag = this.isVisible(this.baseCrudKey);
      if (visibleFlag === undefined) {
        return false;
      }
      return visibleFlag;
    },
  },
  watch: {
    selectedItems: {
      handler(newValue) {
        // Only sync prop changes to store when NOT using store as source of truth
        // When useSelectedItemsStore is true, the store should be the source of truth
        if (!this.useSelectedItemsStore && newValue && newValue.length !== undefined) {
          this.setSelectedItemsOfAllPages([this.baseCrudKey, newValue]);
        }
      },
      immediate: true,
    },
    // Preserve selection when items change (page navigation)
    itemsGetter: {
      handler() {
        if (this.useSelectedItemsStore) {
          // Restore selection from store after navigation to other pages
          const storedSelection = this.selectedItemsOfAllPages(this.baseCrudKey) || [];
          if (storedSelection.length) {
            this.setSelectedItemsOfAllPages([this.baseCrudKey, []]);
            // setTimeout is used to ensure that the store is updated after the current page
            // is rendered
            setTimeout(() => {
              this.setSelectedItemsOfAllPages([this.baseCrudKey, storedSelection]);
            }, 100);
          } else {
            this.setSelectedItemsOfAllPages([this.baseCrudKey, []]);
          }
        }
      },
    },
  },
  created() {
    // first page default
    // const merge = true;
    const criteria = this.skipLimitPage(1);
    window.addEventListener('keydown', this.handleKeyDown);
    this.setCriteria([this.baseCrudKey, criteria, this.mergeCriteria]);
    const paginationItem = {
      itemsperpage: this.getSettings.itemsperpage,
      serverItemsLength: this.getSettings.serverItemsLength,
      footerProps: this.getSettings.footerProps,
    };
    this.setPaginationItems([this.baseCrudKey, paginationItem]);
    // this.emitLoadCRUDList();
    // https://www.raymondcamden.com/2019/08/12/working-with-the-keyboard-in-your-vue-app
    window.addEventListener('keydown', this.shortcutHandler);
  },
  destroyed() {
    // https://stackoverflow.com/a/10444156/10567369
    window.removeEventListener('keydown', this.handleKeyDown);
    window.removeEventListener('keydown', this.shortcutHandler);
  },
  methods: {
    ...mapMutations('base/crud', [
      'setCriteria',
      'setItem',
      'setIndex',
      'setIsVisible',
      'setPaginationItems',
      'setHighlightedId',
      'setSelectedItemsOfAllPages',
    ]),
    ...mapMutations(['setWkstDialog']),
    crudDialogClose() {
      this.$emit('crudDialogClose');
    },
    crudDialogEnter(item) {
      this.$emit('crudDialogEnter', item);
    },
    getAlignment(column) {
      // Return alignment based on the column value
      const header = this.headers.find((h) => h.value === column);
      return header && header.align ? `text-${header.align}` : 'text-left';
    },
    calculateTotal(column) {
      const value = this.itemsGetter.reduce((total, item) => Number(total)
      + (Number(item[column])), 0);
      return amountFormat(amountToNumber(value));
    },
    handlePage(page) { // To be remove - when 'handleOptions' become stable
      const merge = true;
      const criteria = this.skipLimitPage(page);
      this.setCriteria([this.baseCrudKey, criteria, merge]);
      this.emitLoadCRUDList();
    },
    buildSortCriteria(sortByOptions, sortDesc) {
      let sortBy = [];
      if (sortByOptions.length > 0 && sortDesc.length > 0
        && sortByOptions.length === sortDesc.length) {
        for (let i = 0; i < sortDesc.length; i += 1) {
          sortBy.push({
            column: sortByOptions[0],
            direction: sortDesc[0] ? 'desc' : 'asc',
          });
        }
      } else if (sortDesc.length === 0 || sortByOptions.length === 0) {
        if (!this.defaultSortBy) {
          console.warn('no default sortBy is set');
        }
        // default sort
        sortBy = this.defaultSortBy || [
          { column: '_id', direction: 'desc' },
        ];
      }
      return sortBy;
    },
    handleOptions(options) {
      const merge = true;
      const { sortBy: sortByOptions, sortDesc, page } = options;
      const paginationCriteria = this.skipLimitPage(page);
      const sortByCriteria = this.buildSortCriteria(sortByOptions, sortDesc);
      const criteria = { ...paginationCriteria, sortBy: sortByCriteria };
      this.setCriteria([this.baseCrudKey, criteria, merge]);
      this.emitLoadCRUDList();
    },
    handleDialogScrolling() {
      this.$nextTick(() => {
        const accessMultipleDialogBox = document.querySelectorAll('.v-dialog.v-dialog--active');
        for (let i = 0; i < accessMultipleDialogBox.length; i += 1) {
          accessMultipleDialogBox[i].scrollTop = 0;
        }
      });
    },
    handleNewItem(item) {
      /* Before opening a dialog, check that wkst is set or not? */
      const wkst = getWorkstationNumber();
      if (wkst) {
        const newItem = item || this.createNewItem();
        this.setItem([this.baseCrudKey, newItem]);
        this.setIndex([this.baseCrudKey, -1]);
        this.setIsVisible([this.baseCrudKey, true]);
        this.emitActivateItem(newItem, 'newItem');
        this.handleDialogScrolling();
        this.canDeleteInDialogState = false;
      } else {
        this.setWkstDialog(true);
      }
    },
    handleMultipleDelete() {
      this.$emit('handleMultipleDelete');
    },
    handleRowButtonClick(item) {
      this.$emit('emitRowButtonClick', item);
    },
    // An 'iconButton' column was clicked on a row - (row, column). Carried up to the consumer
    // that built the header, like the row button above.
    handleRowIconClick(item, column) {
      this.$emit('emitRowIconClick', item, column);
    },
    // An 'inlineSelect' column changed on a row - (row, field, value). The list owns no rows of
    // its own, so this only carries it up to the consumer that built the header.
    handleInlineSelectChange(item, field, value) {
      this.$emit('emitInlineSelectChange', item, field, value);
    },
    handleEditItem(item, isItCanMove) {
      if (this.removeHighlightOnDoubleClick) this.getHighlightedId = ''; // this will remove 'row selected' if enabled on double click
      const index = this.itemsGetter.indexOf(item);
      if (isItCanMove !== 'canMove') {
        this.setItem([this.baseCrudKey, { ...item }]);
        this.setIndex([this.baseCrudKey, index]);
        this.setIsVisible([this.baseCrudKey, true]);
        this.emitActivateItem(item, 'editItem');
      }
      // this.setItem([this.baseCrudKey, { ...item }]);
      // this.setIndex([this.baseCrudKey, index]);
      // this.setIsVisible([this.baseCrudKey, true]);
      // this.emitActivateItem(item);
      this.canDeleteInDialogState = this.canDeleteInDialog;
      this.handleDialogScrolling();
      this.$emit('onDoubleClicked', item, this.baseCrudKey);
    },
    emitActivateItem(item, addOrEdit) {
      this.$emit('activateItem', item, addOrEdit);
    },
    emitLoadCRUDList() {
      this.$emit('loadCRUDList');
    },
    emitUpsertItem(item) {
      this.$emit('upsertItem', item);
    },
    emitInvalidItem(item) {
      this.$emit('invalidItem', item);
    },
    emitDeleteItem(item) {
      this.$emit('deleteItem', item);
    },
    shortcutHandler(e) {
      if (this.canAdd && isInsert(e) && !this.isVisibleProp) {
        this.handleNewItem();
        // important as per v-dialog documentation
        e.stopPropagation();
      }
    },
    handleClickedTasks(value, fromWhere) {
      if (fromWhere === 'fromClicked') {
        this.$emit('onSingleClicked', value);
        if (this.onSingleClickOpenDialog) {
          this.handleEditItem(value);
        } else if (this.getHighlightedId !== value._id) {
          this.getHighlightedId = value._id;
          this.setItem([this.baseCrudKey, { ...value }]);
        }
      } else this.getHighlightedId = value || '';
    },
    handleSelectedTasks(value) {
      this.selectedTasks = value || [];
    },
    deleteRowItem(item) {
      this.$emit('emitDeleteRowItem', item);
    },
    downloadRowItem(item) {
      this.$emit('emitDownloadRowItem', item);
    },
    // handleTimeOut() {
    //   const scrollBarClassname = document.getElementsByClassName('v-data-table__wrapper')[0];
    //   // const scrollBarMainClassname = document.getElementsByTagName('html')[0];
    //   scrollBarClassname.style.overflow = 'scroll';
    //   // scrollBarMainClassname.style.overflow = 'scroll';
    // },

    // handleKeyDown will be called automatically when using arrow up
    // or down no need to invoke it anywhere else
    handleKeyDown(event) {
      // const scrollBarClassname = document.getElementsByClassName('v-data-table__wrapper')[0];
      // // const scrollBarMainClassname = document.getElementsByTagName('html')[0];
      // const clickedClassname = document.getElementsByClassName('cyan')[0];
      // let currentIndex = -1;
      // if (this.itemsGetter) {
      //   currentIndex = this.itemsGetter.findIndex((item) => item._id === this.selectedTasks[0]);
      // }
      // scrollBarMainClassname.style.overflow = 'hidden';
      // scrollBarClassname.style.overflow = 'scroll';
      // scrollBarClassname.style.padding = 'scroll';
      // let timer = 0;
      // if (timer >= 0) clearTimeout(timer);
      if ((event.key === 'ArrowUp' || event.key === 'ArrowDown') && (!this.isVisibleProp || !this.showDialog)) {
        this.keyboardShortCutFunc(event);
        // if (currentIndex !== -1) {
        //   // if (timer >= 0) clearTimeout(timer);
        //   const nextIndex = event.key === 'ArrowDown' ? currentIndex + 1 : currentIndex - 1;
        //   // timer = setTimeout(this.handleTimeOut, 1200);
        //   // scrollBarMainClassname.style.overflow = 'hidden';
        //   if (nextIndex >= 0 && nextIndex < this.itemsGetter.length) {
        //     const selectedItem = this.itemsGetter[nextIndex];
        //     this.setItem([this.baseCrudKey, { ...selectedItem }]);
        //     this.$emit('onArrowUpOrDown', selectedItem);
        //     this.selectedTasks = [selectedItem._id];
        //     clickedClassname.scrollIntoView({
        //       block: 'center',
        //     });
        //     // scrollBarMainClassname.scrollTop(0);
        //     // scrollBarMainClassname.scrollTop = 0;
        //     // if (event.key === 'ArrowUp') scrollBarMainClassname.scrollTop = 0;
        //     // // else if (event.key === 'ArrowDown')
        //     // window.scrollTo({ top: 0, behavior: 'smooth' });
        //     // else if (event.key === 'ArrowDown') scrollBarMainClassname.scrollTop = 0;
        //     // scrollBarClassname.style.overflow = 'hidden';
        //     scrollBarClassname.focus();
        //     // timer = setTimeout(this.handleTimeOut, 1200);
        //     // scrollBarMainClassname.style.overflow = 'scroll';
        //   }
        //   // else scrollBarClassname.style.overflow = 'scroll';
        // } else this.selectedTasks = [];
      }
      // else scrollBarClassname.style.overflow = 'scroll';
    },
    keyboardShortCutFunc(event) {
      // const scrollBarClassname = document.getElementsByClassName('v-data-table__wrapper')[0];
      const clickedClassname = document.getElementsByClassName('selected-row-highlight')[0];
      let currentIndex = -1;
      if (this.itemsGetter) {
        currentIndex = this.itemsGetter.findIndex((item) => item._id === this.getHighlightedId);
      }
      if (currentIndex !== -1 && event.key) {
        const nextIndex = event.key === 'ArrowDown' ? currentIndex + 1 : currentIndex - 1;
        if (nextIndex >= 0 && nextIndex < this.itemsGetter.length) {
          const selectedItem = this.itemsGetter[nextIndex];
          this.setItem([this.baseCrudKey, { ...selectedItem }]);
          this.$emit('onArrowUpOrDown', selectedItem);
          this.getHighlightedId = selectedItem._id;
          clickedClassname.scrollIntoView({
            block: 'center',
          });
          // scrollBarClassname.focus();
        }
      } else this.getHighlightedId = '';
    },
  },
};
</script>

<style lang="sass">
// overriding default VDataTable Margins
.v-data-table
  > .v-data-footer
    margin-right: 21px
    > .v-data-footer__select
      margin-right: 18px
    > .v-data-footer__icons-before
      margin-right: 9px
    > .v-data-footer__icons-after
      margin-left: 4px
    > .v-data-footer__select
        display: none
// Tax Type column on the payment grids sits a bit right of Tax ID
#crud-list-2-0 .v-data-table__wrapper .tax-type-col
  padding-left: 32px !important
</style>
